import React from 'react';
import styled from 'styled-components';
import { WarehouseGetDto } from 'svila-common/types/back-end/warehouseGetDTO';

interface WarehousesModalProps {
  open: boolean;
  onClose: () => void;
  warehouses: WarehouseGetDto[];
  loading?: boolean;
}

export default function WarehousesModal({ open, onClose, warehouses, loading }: WarehousesModalProps) {
  if (!open) return null;

  return (
    <div
      style={{
        position: 'fixed',
        zIndex: 1000,
        left: 0,
        top: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 8,
          minWidth: 800,
          maxWidth: 1100,
          padding: 32,
          boxShadow: '0 2px 16px rgba(0,0,0,0.2)',
        }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
          <h4 style={{ margin: 0 }}>Warehouses</h4>
          <button onClick={onClose} style={{ fontSize: 18, border: 'none', background: 'none', cursor: 'pointer' }}>
            ×
          </button>
        </div>
        {loading ? (
          <div>Loading...</div>
        ) : warehouses.length === 0 ? (
          <div>No warehouses found.</div>
        ) : (
          <TableContainer>
            <Table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Country</th>
                  <th>City</th>
                </tr>
              </thead>
              <tbody>
                {warehouses.map((w) => (
                  <tr key={w.id}>
                    <td>{w.name}</td>
                    <td>{w.address?.country?.name || '-'}</td>
                    <td>{w.address?.city?.name || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TableContainer>
        )}
      </div>
    </div>
  );
}

const TableContainer = styled.div`
  max-height: 350px;
  overflow-y: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;

  th, td {
    border: 1px solid #ddd;
    padding: 8px;
  }

  th {
    background-color: rgb(242, 242, 242);
    text-align: left;
    position: sticky;
    top: 0;
    z-index: 1;
    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
  }
`;